import UserSettingsModule from '@/store/UserSettingsModule';
import { getModule } from 'vuex-module-decorators';
import { UserSetting, UserSettingReportName, UserSettingName } from '@/models/UserSetting';
import { CookieStorageService } from '@questelservices/common';
import { CookieKeysEnum } from '@questelservices/common';
import _ from 'lodash';


export class UserSettingsService {
    private userState: UserSettingsModule;
    private cookieService: CookieStorageService = new CookieStorageService();

    constructor(private vuexStore: any) {
        this.userState = getModule(UserSettingsModule, this.vuexStore);
    }

    public getUserSettings(reportName: UserSettingReportName | undefined,
        name: UserSettingName | undefined) : Promise<UserSetting[]> {

        return new Promise(async (resolve, reject) => {
            let settings = await this.getUserSettingsFromCookie();
            let result: UserSetting[]  = [];

            if(settings && settings.length > 0) {
                result = settings.filter((item, index, arr) => 
                    (reportName ? item.ReportName === reportName : true) &&
                    (name ? item.Name === name : true)
                );
            }

            resolve(result);
        })
    }

     public setUserSettings(userSetting : UserSetting[],
        reportName: UserSettingReportName | undefined,
        name: UserSettingName | undefined) : Promise<any> {

        return new Promise(async (resolve, reject) => {
            let settings = await this.getUserSettingsFromCookie();
            let settingsToSave : UserSetting[] = []

            if(!reportName && !name) {
                settingsToSave = userSetting;
            }
            else {
                _.remove(settings, (item : UserSetting) => 
                    (reportName ? item.ReportName === reportName : true) &&
                    (name ? item.Name === name : true)
                );

                settingsToSave = _.concat(settings, userSetting);
            }

        
            await this.userState.setUserSettings(settingsToSave);

            resolve();
        })
       
    }

    private getUserSettingsFromCookie() : Promise<UserSetting[]> {
        return new Promise(async (resolve, reject) => {
            let settingsStr : string = this.userState.userSettings;
            //this.cookieService.getItem(CookieKeysEnum.UserSettings);
            let settings : UserSetting[] = [];

            if(settingsStr) {
                settings = JSON.parse(settingsStr);
            }

            resolve(settings);

        });
    }
}